import { useEffect, useRef, useState } from 'react';

import { cn } from '@/utils/tailwind';

export const VariableInputForm = (props: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  endAdornment?: string;
  updateEveryChange?: boolean;
  readOnly?: boolean;
}) => {
  const ref = useRef<HTMLFormElement>(null);
  const [state, setState] = useState(props.value);

  const isReadOnly = props.readOnly ?? false;

  useEffect(() => setState(props.value), [props.value]);

  return (
    <form
      ref={ref}
      onSubmitCapture={(e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isReadOnly) return;

        const data = new FormData(e.currentTarget);
        const value = data.get('value');
        if (value != null && typeof value === 'string') {
          props.onChange(value);
        }
      }}
      className={props.className}
    >
      <div
        className={cn(
          'inline-grid flex-shrink-0 grid-cols-1 grid-rows-1 rounded-md border border-tertiary bg-background focus-within:border-brand',
          props.endAdornment && 'grid-cols-[auto,auto]',
          isReadOnly && 'cursor-not-allowed opacity-50'
        )}
      >
        <input
          placeholder={props.placeholder}
          className={cn(
            'col-[1] row-[1] border-none bg-transparent px-2 py-1 text-xs',
            'min-w-0 text-transparent caret-black outline-none placeholder:text-quaternary dark:caret-slate-200',
            isReadOnly && 'cursor-not-allowed'
          )}
          name="value"
          value={state}
          readOnly={isReadOnly}
          onChange={(e) => {
            if (isReadOnly) return;
            setState(e.target.value);
            if (props.updateEveryChange) {
              props.onChange(e.target.value);
            }
          }}
          onBlur={() => {
            if (isReadOnly) return;
            ref.current?.requestSubmit();
          }}
        />
        <div
          className={cn(
            'col-[1] row-[1] border-none bg-transparent px-2 py-1 text-xs',
            'pointer-events-none'
          )}
        >
          {state}{' '}
        </div>

        {props.endAdornment && (
          <span className="rounded-r-md border-l border-tertiary bg-secondary px-2 py-0.5 text-tertiary">
            {props.endAdornment}
          </span>
        )}
      </div>
    </form>
  );
};
